import { gsap } from "gsap"
import { useRef, useEffect } from "react"
export function BackgroundTexts () {

  const timeline = useRef()

  useEffect(() => {
    timeline.current = gsap.timeline().to("#background > div", { scale: 1,  ease: "bounce"})

    return () => {
      timeline.current.kill()
    }
  }, [])

  return (
    <div id="background" className="fixed pointer-events-none w-screen h-screen z-30 hidden lg:block opacity-95">
      {/* Left */}

      <div className="card absolute top-52 left-20 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center -rotate-45 z-40">
        Tôi có nên quay lại với người yêu cũ?
      </div>
      <div className="absolute top-52 left-20 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center -rotate-12">

      </div>

      <div className="absolute bottom-12 left-52 text-2xs  text-center scale-150 font-semibold text-gray-400 bg-primary border border-primary rounded-lg p-4 h-52 w-36 flex items-center rotate-[36deg]">

      </div>

      <div className="absolute bottom-14 left-56 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center -rotate-[4deg]">
        Wow, tôi đoán bạn là lập trình viên?
      </div>
      <div className="absolute bottom-12 left-52 text-2xs text-center scale-150 font-semibold text-gray-400 bg-primary border border-primary rounded-lg p-4 h-52 w-36 flex items-center rotate-12">

      </div>


      {/* Right */}

      <div className="absolute -top-8 right-12 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center rotate-[45deg]">
        Mọi chuyện đều là hiển nhiên
      </div>

      <div className="absolute top-64 right-16 text-2xs text-center scale-150 font-semibold text-gray-400 bg-primary border border-primary rounded-lg p-4 h-52 w-36 flex items-center rotate-[20deg]">

      </div>
      <div className="absolute top-64 right-16 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center rotate-12">

      </div>
      <div className="absolute top-64 right-16 text-2xs text-center scale-150 font-semibold text-gray-400 bg-background border border-primary rounded-lg p-4 h-52 w-36 flex items-center -rotate-[36deg]">
        Tôi có nên đi du lịch trong năm nay?
      </div>





    </div>
  )
}
